module.exports = __webpack_public_path__ + "img/intellectual-capital.7356715c.svg";